module.exports = __webpack_public_path__ + "static/Advantage01@1x.5817b189.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/events/new/Advantage01@1x.png
// module id = 683
// module chunks = 216210090109534